export default __webpack_public_path__ + "static/media/dapps-titleMobile.d43ef3dc.svg";